import { Extension, InputRule } from "@tiptap/core";

// Brand-word auto-correct as you type: "kuika" → "Kuika", "jira" → "JIRA". Each fires only when the
// word is completed with a delimiter (space/punctuation), keeps that delimiter, and — being a
// ProseMirror input rule — is reverted by a single Backspace right after. Requiring the trailing
// delimiter also skips quoted words ("kuika", 'jira', `kuika`): the closing quote sits between the
// word and the delimiter, so the pattern doesn't match.
function brandRule(word: string, replacement: string): InputRule {
  return new InputRule({
    find: new RegExp(`(?:^|[^\\w'"\`])(${word})([\\s.,!?;:])$`, "i"),
    handler: ({ state, range, match }) => {
      const lead: string = match[0].slice(0, match[0].length - match[1].length - match[2].length);
      state.tr.insertText(`${lead}${replacement}${match[2]}`, range.from, range.to);
    }
  });
}

export const BrandAutocorrect: Extension = Extension.create({
  name: "brandAutocorrect",
  addInputRules() {
    return [brandRule("kuika", "Kuika"), brandRule("jira", "JIRA")];
  }
});
